module.exports = __webpack_public_path__ + "img/aba_shata_yes.4b8ca6c4.png";